<div class="container py-4">
	<nz-spin [nzSpinning]="loading">
		<div *ngIf="result">
			<div class="d-flex justify-content-between align-items-center mb-4">
				<div>
					<h2>{{ result.report.name }}</h2>
					<p class="text-muted mb-0">
						{{
							'cross-formation-report_respondants-count'
								| translate
						}}: {{ result.respondant_count }}
					</p>
				</div>
				<div class="no-print">
					<button
						nz-button
						nzType="default"
						class="mr-2"
						(click)="goBack()"
					>
						{{ 'cross-formation-report_back-btn' | translate }}
					</button>
					<button
						nz-button
						nzType="primary"
						[nzLoading]="printLoading"
						(click)="printReport()"
					>
						<i nz-icon nzType="printer" *ngIf="!printLoading"></i>
						{{ 'cross-formation-report_print-btn' | translate }}
					</button>
				</div>
			</div>

			<div *ngFor="let g of displayGraphs" class="graph-container mb-4">
				<h4>{{ g.title }}</h4>

				<div [ngSwitch]="g.type">
					<app-atom-graph-bar
						*ngSwitchCase="'bar'"
						[data]="g.data"
						[colors]="g.colors"
						[maxAxis]="g.maxAxis"
						[showAverage]="g.showAverage"
						[isPrinting]="isPrinting"
						[render]="true"
					></app-atom-graph-bar>

					<app-atom-graph-radar
						*ngSwitchCase="'radar'"
						[data]="g.data"
						[color]="g.colors[0]"
						[maxAxis]="g.maxAxis"
						[showAverage]="g.showAverage"
						[isPrinting]="isPrinting"
						[render]="true"
					></app-atom-graph-radar>

					<app-atom-graph-average
						*ngSwitchCase="'average'"
						[data]="g.data"
						[showAverage]="g.showAverage"
						[maxAxis]="g.maxAxis"
						[render]="true"
					></app-atom-graph-average>

					<app-atom-graph-gauge-svg
						*ngSwitchCase="'gauge'"
						[valueAxe1]="g.valueAxe1"
						[valueAxe2]="g.valueAxe2"
						[colors]="g.colors"
						[labelMin]="g.labelMin"
						[labelMax]="g.labelMax"
					></app-atom-graph-gauge-svg>

					<app-atom-graph-grouped-bar
						*ngSwitchCase="'grouped_bar'"
						[data]="g.data"
						[colors]="g.colors"
						[maxAxis]="g.maxAxis"
						[showAverage]="g.showAverage"
						[isPrinting]="isPrinting"
						[render]="true"
					></app-atom-graph-grouped-bar>
				</div>
			</div>

			<div
				*ngIf="displayGraphs.length === 0 && !loading"
				class="text-center text-muted py-5"
			>
				{{ 'common_empty' | translate }}
			</div>

			<!-- Free-text comments (only when "Afficher les commentaires" was checked) -->
			<div *ngIf="hasComments" class="comments-section mt-5">
				<h3>
					{{ 'cross-formation-report_comments-title' | translate }}
				</h3>
				<div *ngFor="let c of comments" class="comment-group mb-4">
					<h5 *ngIf="c.question">{{ c.question }}</h5>
					<ul class="comment-list">
						<li *ngFor="let a of c.answers">{{ a }}</li>
					</ul>
				</div>
			</div>
		</div>
	</nz-spin>
</div>
